// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_recovery_model from "./web_recovery_model.js";
import * as Mapre_web__Web_subscription from "./web_subscription.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Printf from "melange/printf.js";
import * as Stdlib__String from "melange/string.js";

const initial = {
  draft: "",
  attachments: Mapre_web__Web_attachments_model.initial,
  control: undefined,
  attempt: undefined,
  message: "",
  denied: false,
  subscription: undefined,
  budget: "",
  continuing_from: undefined
};

function resumption(row) {
  const value = Mapre_wire__Json.get(row, "resume");
  if (Caml_obj.caml_equal(value, null)) {
    return;
  }
  const provider = Mapre_wire__Json.string(value, "provider");
  const connection = Mapre_wire__Json.string(value, "connection_id");
  const budget = Mapre_wire__Json.integer(value, "budget_microusd");
  if (budget < 1 || connection === "" || !Stdlib__List.mem(provider, {
      hd: "chatgpt",
      tl: {
        hd: "devin",
        tl: {
          hd: "cursor",
          tl: {
            hd: "grok",
            tl: /* [] */ 0
          }
        }
      }
    })) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_resume_control"
      });
  }
  return {
    provider,
    connection,
    budget
  };
}

function decode(json) {
  const row = Mapre_wire__Json.get(json, "run");
  let control;
  if (Caml_obj.caml_equal(row, null)) {
    control = undefined;
  } else {
    const version = Mapre_wire__Json.integer(row, "version");
    if (version < 0) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_message_control"
        });
    }
    const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(row, "can_send"));
    let can_send;
    if (value !== undefined) {
      can_send = value;
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_message_control"
        });
    }
    const fields = Js__Js_json.decodeObject(row);
    let tmp;
    if (fields !== undefined) {
      tmp = Stdlib__Option.bind(Js__Js_dict.get(Caml_option.valFromOption(fields), "recovery"), Mapre_web__Web_recovery_model.decode);
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_message_control"
        });
    }
    control = {
      id: Mapre_wire__Json.string(row, "id"),
      version,
      can_send,
      reason: Js__Js_json.decodeString(Mapre_wire__Json.get(row, "reason")),
      resume: resumption(row),
      resume_reason: Js__Js_json.decodeString(Mapre_wire__Json.get(row, "resume_reason")),
      recovery: tmp
    };
  }
  return [
    control,
    Stdlib__Array.to_list(Stdlib__Array.map((function (row) {
      return Mapre_wire__Json.string(row, "command_id");
    }), Mapre_wire__Json.array(json, "commands")))
  ];
}

function accepted(t, id, version) {
  const a = t.attempt;
  if (a === undefined) {
    return t;
  }
  if (a.id !== id) {
    return t;
  }
  const match = a.mode;
  let tmp;
  let exit = 0;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    exit = 1;
  } else {
    tmp = Stdlib__Option.bind(t.control, (function (c) {
      if (c.id !== a.run) {
        return c;
      }
      
    }));
  }
  if (exit === 1) {
    tmp = Stdlib__Option.map((function (c) {
      if (c.id === a.run && version !== undefined) {
        return {
          id: c.id,
          version: c.version > version ? c.version : version,
          can_send: c.can_send,
          reason: c.reason,
          resume: c.resume,
          resume_reason: c.resume_reason,
          recovery: c.recovery
        };
      } else {
        return c;
      }
    }), t.control);
  }
  const match$1 = a.mode;
  let tmp$1;
  tmp$1 = /* tag */ typeof match$1 !== "object" && typeof match$1 !== "function" ? t.continuing_from : (
      Stdlib__Option.fold(false, (function (c) {
        return c.id !== a.run;
      }), t.control) ? undefined : a.run
    );
  return {
    draft: t.draft === a.text ? "" : t.draft,
    attachments: Mapre_web__Web_attachments_model.initial,
    control: tmp,
    attempt: undefined,
    message: "",
    denied: t.denied,
    subscription: t.subscription,
    budget: t.budget,
    continuing_from: tmp$1
  };
}

function update(t, draft) {
  if (/* tag */ typeof draft !== "object" && typeof draft !== "function") {
    switch (draft) {
      case /* Uncertain_delivery */ 4 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: Stdlib__Option.map((function (a) {
            return {
              id: a.id,
              run: a.run,
              version: a.version,
              text: a.text,
              attachments: a.attachments,
              phase: /* Uncertain */ 1,
              mode: a.mode
            };
          }), t.attempt),
          message: "Message delivery is uncertain. Refresh or retry the same message.",
          denied: t.denied,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Denied */ 5 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: undefined,
          message: "Permission denied. Refresh your access before sending.",
          denied: true,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Access_refreshed */ 6 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: t.attempt,
          message: "",
          denied: false,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      default:
        return t;
    }
  } else {
    switch (draft.TAG) {
      case /* Draft */ 0 :
        return {
          draft: draft._0,
          attachments: t.attachments,
          control: t.control,
          attempt: t.attempt,
          message: t.message,
          denied: t.denied,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Choose */ 1 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: t.attempt,
          message: t.message,
          denied: t.denied,
          subscription: draft._0,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Budget */ 2 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: t.attempt,
          message: t.message,
          denied: t.denied,
          subscription: t.subscription,
          budget: draft._0,
          continuing_from: t.continuing_from
        };
      case /* Loaded */ 3 :
        const control = Stdlib__Option.map((function (c) {
          const old = t.control;
          if (old !== undefined && old.id === c.id) {
            return {
              id: c.id,
              version: old.version > c.version ? old.version : c.version,
              can_send: c.can_send,
              reason: c.reason,
              resume: c.resume,
              resume_reason: c.resume_reason,
              recovery: c.recovery
            };
          } else {
            return c;
          }
        }), draft._0);
        const budget = t.budget !== "" ? t.budget : Stdlib__Option.fold("", (function (r) {
            let budget = r.budget;
            const value = Curry._1(Stdlib__Printf.sprintf({
              TAG: /* Format */ 0,
              _0: {
                TAG: /* Float */ 8,
                _0: [
                  /* Float_flag_ */ 0,
                  /* Float_f */ 0
                ],
                _1: /* No_padding */ 0,
                _2: {
                  TAG: /* Lit_precision */ 0,
                  _0: 6
                },
                _3: /* End_of_format */ 0
              },
              _1: "%.6f"
            }), budget / 1000000);
            const minimum = Stdlib__String.index(value, /* '.' */46) + 3 | 0;
            const last = function (_n) {
              while (true) {
                const n = _n;
                if (!(n > minimum && Caml_string.get(value, n - 1 | 0) === /* '0' */48)) {
                  return n;
                }
                _n = n - 1 | 0;
                continue;
              };
            };
            return Stdlib__String.sub(value, 0, last(value.length));
          }), Stdlib__Option.bind(control, (function (c) {
            return c.resume;
          })));
        const match = t.continuing_from;
        const continuing_from = match !== undefined && control !== undefined && match !== control.id ? undefined : t.continuing_from;
        const t_draft = t.draft;
        const t_attachments = t.attachments;
        const t_attempt = t.attempt;
        const t_message = t.message;
        const t_denied = t.denied;
        const t_subscription = t.subscription;
        const t$1 = {
          draft: t_draft,
          attachments: t_attachments,
          control,
          attempt: t_attempt,
          message: t_message,
          denied: t_denied,
          subscription: t_subscription,
          budget,
          continuing_from
        };
        const a = t_attempt;
        if (a !== undefined && Stdlib__List.mem(a.id, draft._1)) {
          return accepted(t$1, a.id, a.phase === /* Admitted */ 2 ? undefined : a.version + 1 | 0);
        } else {
          return t$1;
        }
      case /* Started */ 4 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: draft._0,
          message: "",
          denied: t.denied,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Accepted */ 5 :
        return accepted(t, draft._0, draft._1);
      case /* Admitted */ 6 :
        let id = draft._0;
        const a$1 = t.attempt;
        return {
          draft: a$1 !== undefined && a$1.id === id && t.draft === a$1.text ? "" : t.draft,
          attachments: Mapre_web__Web_attachments_model.initial,
          control: t.control,
          attempt: Stdlib__Option.map((function (a) {
            if (a.id === id) {
              return {
                id: a.id,
                run: a.run,
                version: a.version,
                text: a.text,
                attachments: a.attachments,
                phase: /* Admitted */ 2,
                mode: a.mode
              };
            } else {
              return a;
            }
          }), t.attempt),
          message: "",
          denied: t.denied,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
      case /* Reconcile */ 7 :
        const a$2 = t.attempt;
        if (a$2 !== undefined && Stdlib__List.mem(a$2.id, draft._0)) {
          return accepted(t, a$2.id, a$2.phase === /* Admitted */ 2 ? undefined : a$2.version + 1 | 0);
        } else {
          return t;
        }
      case /* Rejected */ 8 :
        return {
          draft: t.draft,
          attachments: t.attachments,
          control: t.control,
          attempt: undefined,
          message: draft._0,
          denied: t.denied,
          subscription: t.subscription,
          budget: t.budget,
          continuing_from: t.continuing_from
        };
    }
  }
}

function can_send(t) {
  if (!t.denied && t.attempt === undefined && (Stdlib__String.trim(t.draft) !== "" || Caml_obj.caml_notequal(t.attachments.items, /* [] */ 0)) && Mapre_web__Web_attachments_model.ready(t.attachments)) {
    return Stdlib__Option.fold(false, (function (c) {
      return c.can_send;
    }), t.control);
  } else {
    return false;
  }
}

function resume(t) {
  return Stdlib__Option.bind(t.control, (function (c) {
    return c.resume;
  }));
}

function money(text) {
  const value = Stdlib.float_of_string_opt(text);
  if (value === undefined) {
    return;
  }
  if (!(Stdlib__Float.is_finite(value) && value > 0 && value <= 2147)) {
    return;
  }
  const amount = Math.round(value * 1000000) | 0;
  if (amount > 0) {
    return amount;
  }
  
}

function accounts(t, subscriptions) {
  const match = t.subscription;
  const match$1 = resume(t);
  if (match !== undefined || match$1 === undefined) {
    return t;
  } else {
    return {
      draft: t.draft,
      attachments: t.attachments,
      control: t.control,
      attempt: t.attempt,
      message: t.message,
      denied: t.denied,
      subscription: Stdlib__List.find_opt((function (s) {
        if (s.id === match$1.connection && s.ownership === "personal" && s.provider === match$1.provider) {
          return Mapre_web__Web_subscription.selectable(s);
        } else {
          return false;
        }
      }), subscriptions),
      budget: t.budget,
      continuing_from: t.continuing_from
    };
  }
}

function continuation_ready(t, subscriptions) {
  const match = resume(t);
  const match$1 = t.subscription;
  if (match !== undefined && match$1 !== undefined && money(t.budget) !== undefined) {
    return Stdlib__List.exists((function (s) {
      if (s.id === match$1.id && s.authorization_version === match$1.authorization_version && s.provider === match.provider) {
        return Mapre_web__Web_subscription.selectable(s);
      } else {
        return false;
      }
    }), subscriptions);
  } else {
    return false;
  }
}

function ready(t, subscriptions) {
  const match = resume(t);
  if (match !== undefined) {
    if (!t.denied && t.attempt === undefined && (Stdlib__String.trim(t.draft) !== "" || Caml_obj.caml_notequal(t.attachments.items, /* [] */ 0)) && Mapre_web__Web_attachments_model.ready(t.attachments)) {
      return continuation_ready(t, subscriptions);
    } else {
      return false;
    }
  } else {
    return can_send(t);
  }
}

function mode(t) {
  const match = resume(t);
  const match$1 = t.subscription;
  const match$2 = money(t.budget);
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined) {
    return {
      TAG: /* Resume */ 0,
      _0: {
        connection_id: match$1.id,
        connection_version: match$1.authorization_version,
        budget_microusd: match$2
      }
    };
  } else {
    return /* Prompt */ 0;
  }
}

export {
  initial,
  decode,
  update,
  can_send,
  resume,
  accounts,
  continuation_ready,
  ready,
  mode,
}
/* Mapre_web__Web_attachments_model Not a pure module */
